// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonGeneric {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 17px;
  padding: 15px;
  cursor: pointer;
}

.buttonGeneric:disabled {
  cursor: not-allowed;
  background-color: #d9d9d9;
}

.imgIcone {
  margin-right: 5px;
}

.buttonGeneric:hover {
  background-color: #dde5f0;
}
`, "",{"version":3,"sources":["webpack://./src/componentes/Pagination/pagination.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".buttonGeneric {\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n  font-size: 17px;\n  padding: 15px;\n  cursor: pointer;\n}\n\n.buttonGeneric:disabled {\n  cursor: not-allowed;\n  background-color: #d9d9d9;\n}\n\n.imgIcone {\n  margin-right: 5px;\n}\n\n.buttonGeneric:hover {\n  background-color: #dde5f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
